// extracted by mini-css-extract-plugin
module.exports = {"container":"s_c","chevvvy":"s_T","chevvvy__link":"s_V","chevvvy__box":"s_W","chevvvy__box_wrap":"s_X","chevvvy__text":"s_Y","chevvvy__text_wrap":"s_Z"};